module.exports = __webpack_public_path__ + "static/media/avatar-8.a516ae89.svg";